/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".paint-palette-swatch[_ngcontent-%COMP%]{cursor:pointer;display:inline-block;border-radius:50%;width:16px;height:16px;position:relative}"];
export { styles as styles };
